<template lang="html">
  <div :class="wrapperClass">
    <a
      :class="{ 'pointer-events-none': isSlider }"
      :href="data.link?.url"
      :target="data.link?.target"
    >
      <img
        :src="data.image"
        :alt="`${data.brand} ${data.model}`"
        loading="lazy"
        class="w-full max-w-4xl mx-auto object-cover aspect-used-car"
      />
      <h3 class="mt-5 font-bold text-black dark:text-gold-50 text-xl">
        {{ data.brand }} {{ data.model }}
      </h3>
      <p class="text-black dark:text-white font-light mt-1.5">
        {{ data.modelYear }} {{ data.variant }}
      </p>
      <ul class="font-bold text-lg mt-2.5 mb-6" v-if="data.price > 0">
        <li v-if="!data.isMarketedAsLeasingCar">
          Totalpris: <span>{{ $filters.formatNumber(data.price) }},-</span>
        </li>
        <li>
          Månedspris:
          <span
            >{{
              $filters.formatNumber(
                data.isMarketedAsLeasingCar ? data.price : mndprice
              )
            }}
            ,-</span
          >
        </li>
      </ul>
    </a>

    <a
      class="btn btn--transparent-black w-full"
      :href="data.link?.url"
      :target="data.link?.target"
    >
      {{ data.link?.title }}
    </a>
  </div>
</template>

<script>
import rates from '../data/rates';
import Helper from '../helper/FinancialHelper';

export default {
  name: 'UsedCar',
  props: ['car', 'class'],
  data() {
    return {
      data: [],
      mndprice: 0,
      wrapperClass: this.class + ' flex flex-col justify-between',
      isSlider: this.class?.includes('keen-slider__slide'),
    };
  },
  mounted() {
    this.data = JSON.parse(this.car);
    const carRate = rates.standard;
    const capital = Helper.getCapital(this.data.price, carRate.capital);

    const realPrice = Helper.calculateRealPrice(
      this.data.price,
      carRate.registrationCost,
      carRate.preparationFee,
      capital
    );

    this.mndprice = Helper.calculateMonthlyPrice(
      realPrice,
      window.interestRate,
      carRate.years,
      carRate.monthlyCost
    );
  },
};
</script>
